module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/triangle-arrow-30760900b433665c624682a968b91dc0.svg&quot;;"